import type { NextPage } from "next";

import { PageSeo } from "scmp-app/components/meta";

const MenuPage: NextPage = () => (
  <>
    <PageSeo />
    <div>MenuPage</div>
  </>
);

export default MenuPage;
